// Sample cover letter data for template previews in gallery
export const getSampleCoverLetterData = () => {
  return {
    // Personal Information
    fullName: "John Doe",
    title: "Senior Software Engineer",
    email: "john.doe@email.com",
    phone: "+1 (555) 123-4567",
    location: "San Francisco, CA",
    linkedin: "https://linkedin.com/in/johndoe",
    github: "https://github.com/johndoe",
    portfolio: "https://johndoe.dev",
    
    // Company/Position Details
    companyName: "TechVista Inc.",
    companyLocation: "San Francisco, CA",
    jobTitle: "Senior Software Engineer",
    hiringManagerName: "Sarah Mitchell",
    hiringManagerSalutation: "Ms. Mitchell",
    
    // Current Position
    currentRole: "Software Engineer",
    currentCompany: "InnovateTech Solutions",
    
    // Professional Details
    yearsOfExperience: "8+",
    primarySkills: "full-stack development, cloud architecture, and team leadership",
    
    // Key Achievements
    keyAchievementOne: "led the development of a microservices architecture that improved system scalability by 300% while reducing infrastructure costs by 40%",
    keyAchievementTwo: "mentored a team of 5 junior developers, resulting in a 50% increase in code quality metrics and faster delivery timelines",
    keyAchievementThree: "implemented CI/CD pipelines that reduced deployment time from 2 hours to 15 minutes",
    
    // Skills & Technologies
    toolsAndTechnologies: "React, Node.js, AWS, Docker, Kubernetes, and PostgreSQL",
    additionalSkills: "TypeScript, GraphQL, microservices architecture, and agile methodologies",
    
    // Company-Specific Interest
    companyMotivation: "revolutionizing how businesses leverage technology to solve complex problems",
    companyMission: "revolutionizing how businesses leverage technology to solve complex problems",
    whyInterested: "TechVista's commitment to innovation and sustainable technology solutions aligns perfectly with my professional values and career goals",
    
    // Value Proposition
    uniqueValue: "combine technical expertise with strong leadership abilities to drive successful project outcomes",
    relevantExperience: "extensive background in building scalable applications and fostering collaborative team environments",
    
    // Closing
    availabilityDate: "two weeks",
    currentDate: new Date().toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    }),
    
    // Education (if needed)
    degree: "Bachelor of Science in Computer Science",
    university: "University of California, Berkeley",
    graduationYear: "2017",
    
    // Additional Context
    howFoundPosition: "LinkedIn",
    referralName: "",
    
    // Soft Skills
    keyStrengths: "problem-solving, effective communication, and adaptability",
    leadershipExperience: "led cross-functional teams of up to 10 people on high-stakes projects",
    
    // Project Highlights
    notableProject: "e-commerce platform serving over 1 million daily users",
    projectImpact: "increased conversion rates by 35% and reduced page load times by 60%",
    
    // Professional Goals
    careerGoal: "transition into a senior leadership role where I can mentor teams and architect innovative solutions",
    longTermVision: "contribute to cutting-edge technology that makes a meaningful impact on users' lives"
  };
};

// Get a minimal version for quick previews
export const getMinimalCoverLetterData = () => {
  return {
    fullName: "John Doe",
    email: "john.doe@email.com",
    phone: "+1 (555) 123-4567",
    location: "San Francisco, CA",
    companyName: "TechVista Inc.",
    companyLocation: "San Francisco, CA",
    jobTitle: "Senior Software Engineer",
    hiringManagerName: "Sarah Mitchell",
    hiringManagerSalutation: "Ms. Mitchell",
    currentRole: "Software Engineer",
    currentCompany: "InnovateTech Solutions",
    yearsOfExperience: "8+",
    primarySkills: "full-stack development and cloud architecture",
    keyAchievementOne: "led development of scalable microservices",
    keyAchievementTwo: "mentored a team of 5 developers",
    toolsAndTechnologies: "React, Node.js, AWS, Docker",
    currentDate: new Date().toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    })
  };
};
